import type { ReactNode } from "react";
import Layout from "../layout";

export type JournalLayoutProps = Parameters<typeof Layout>["0"] & {
  instanceId?: string;
};

export default function ({ children, instanceId, ...props }: JournalLayoutProps): ReactNode {
  return <Layout {...props}>{children}</Layout>;
}
